







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AppColorBadge extends Vue {
  @Prop({ type: String, default: '' })
  readonly mod!: string;

  get modClasses(): Array<string> {
    const { mod } = this;
    if (!mod.length) return [];
    return mod.split(', ').map((item) => `app-color-badge_${item}`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppColorBadge/AppColorBadge.vue